<template>
  <div class="order-list-page">
    <!-- 自定义标签页区域 -->
    <div class="tabs-container">
      <div class="custom-tabs">
        <!-- Tab 头部 -->
        <div class="tabs-header">
          <div
            v-for="tab in tabs"
            :key="tab.id"
            :class="['tab-item', { active: activeName === tab.id }]"
            @click="activeName = tab.id"
          >
            <span class="tab-label">{{ tab.name }}</span>
            <div class="tab-indicator"></div>
          </div>
        </div>

        <!-- Tab 内容 -->
        <div class="tabs-content">
          <div v-for="tab in tabs" :key="tab.id" :class="['tab-pane', { active: activeName === tab.id }]">
            <OrderItem ref="OrderItem" :tabItem="tab" v-if="activeName === tab.id" class="order-item-content" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderItem from "./components/OrderItem.vue";
import { getOrdersCounts } from "@/api/order";

export default {
  name: "orderList",
  components: {
    OrderItem
  },
  data() {
    return {
      keyScope: "OrderList",
      activeName: "0",
      countObj: {}
    };
  },
  mounted() {
    this.getOrdersCountsFn();
    this.$bus.$on("refreshOrdersCount", () => {
      this.getOrdersCountsFn();
    });
  },
  destroyed() {
    this.$bus.$off("refreshOrdersCount");
  },
  activated() {
    if (this.$route.query && this.$route.query.id) {
      this.activeName = this.$route.query.id;
    }
    setTimeout(() => {
      this.$hotkeys("*", this.keyScope, this.handleKeyCode);
      this.$hotkeys.setScope(this.keyScope);
    }, 500);
  },
  deactivated() {
    this.$hotkeys.unbind("*", this.keyScope);
  },
  computed: {
    tabs() {
      return [
        { id: "0", name: `全部订单(${this.countObj.total || 0})` },
        { id: "1", name: `待确认(${this.countObj.toConfirm || 0})` },
        { id: "9", name: `待付款(${this.countObj.toPay || 0})` },
        { id: "2", name: `待发货(${this.countObj.toDeliver || 0})` },
        { id: "3", name: `待收货(${this.countObj.toReceive || 0})` },
        { id: "4", name: `已完成(${this.countObj.completed || 0})` }
      ];
    }
  },
  methods: {
    getOrdersCountsFn() {
      getOrdersCounts()
        .then(res => {
          this.countObj = res || {};
        })
        .catch(err => {
          this.$message.error(err?.message);
        });
    },
    handleKeyCode(e) {
      switch (e.code) {
        case "F3":
          e.preventDefault();
          e.stopPropagation();
          if (this.$refs.OrderItem[0].canDeleteBatch) {
            this.$refs.OrderItem[0].deleteBatchFn();
          }
          break;
        case "F5":
          e.preventDefault();
          e.stopPropagation();
          this.$refs.OrderItem[0].queryFn();
          break;
        case "F6":
          e.preventDefault();
          e.stopPropagation();
          this.$refs.OrderItem[0].resetFn();
          break;
        case "F9":
          e.preventDefault();
          e.stopPropagation();
          if (this.$refs.OrderItem[0].canPayBatch) {
            this.$refs.OrderItem[0].toPayBatchFn();
          }
          break;
        case "F10":
          e.preventDefault();
          e.stopPropagation();
          if (this.$refs.OrderItem[0].canConfirmReceiptBatch) {
            this.$refs.OrderItem[0].confirmReceiptBatchFn();
          }
          break;
        case "Escape":
          e.preventDefault();
          e.stopPropagation();
          if (this.$refs.OrderItem[0].canCancelBatch) {
            this.$refs.OrderItem[0].cancelBatchFn();
          }
          break;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.order-list-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f5f7fa;
  position: relative;
}
.tabs-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  // padding: 8px;
  background: #f5f7fa;
}

.custom-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.tabs-header {
  display: flex;
  background: white;
  border-bottom: 1px solid #e8e8e8;
  padding: 0 16px;

  .tab-item {
    position: relative;
    height: 48px;
    line-height: 48px;
    padding: 0 20px;
    font-size: 14px;
    font-weight: 500;
    color: #606266;
    cursor: pointer;
    transition: all 0.3s ease;
    user-select: none;

    &:hover {
      color: var(--color-primary);
    }

    &.active {
      color: var(--color-primary);
      font-weight: 600;

      .tab-indicator {
        position: absolute;
        bottom: 0;
        left: 20px;
        right: 20px;
        height: 3px;
        background: var(--color-primary);
        border-radius: 2px 2px 0 0;
        animation: slideIn 0.3s ease;
      }
    }
  }
}

@keyframes slideIn {
  from {
    transform: scaleX(0.8);
    opacity: 0;
  }
  to {
    transform: scaleX(1);
    opacity: 1;
  }
}

.tabs-content {
  // flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  height: calc(100% - 50px);
  .tab-pane {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;

    &.active {
      opacity: 1;
      visibility: visible;
    }
  }
}

.order-item-content {
  height: 100%;
  overflow: hidden;
}

.shortcut-hint {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  z-index: 2000;
  padding: 24px;
  min-width: 300px;

  .hint-content {
    position: relative;

    h3 {
      margin: 0 0 16px;
      font-size: 18px;
      font-weight: 600;
      color: #303133;
      text-align: center;
    }

    .shortcut-list {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;

      .shortcut-item {
        display: flex;
        align-items: center;
        padding: 8px 12px;
        background: #f5f7fa;
        border-radius: 6px;

        .key {
          background: var(--color-primary);
          color: white;
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 12px;
          font-weight: 600;
          margin-right: 8px;
          min-width: 40px;
          text-align: center;
        }

        .action {
          font-size: 14px;
          color: #606266;
        }
      }
    }

    .close-hint {
      position: absolute;
      top: -8px;
      right: -8px;
      font-size: 20px;
      color: #909399;
      cursor: pointer;
      background: white;
      border-radius: 50%;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      transition: all 0.2s ease;

      &:hover {
        color: var(--color-primary);
        transform: scale(1.1);
      }
    }
  }
}

.shortcut-trigger {
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 48px;
  height: 48px;
  background: var(--color-primary);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
  cursor: pointer;
  z-index: 1000;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(64, 158, 255, 0.5);
  }

  i {
    font-size: 20px;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .page-header {
    padding: 16px;

    .header-content {
      flex-direction: column;
      align-items: flex-start;

      .page-title {
        margin-bottom: 12px;
        font-size: 20px;
      }

      .order-stats {
        width: 100%;
        justify-content: space-around;

        .stat-item {
          .stat-value {
            font-size: 20px;
          }
        }
      }
    }
  }

  .tabs-container {
    padding: 16px 16px 0;
  }

  .tabs-header {
    padding: 0 8px;
    overflow-x: auto;
    white-space: nowrap;

    .tab-item {
      padding: 0 12px;
      font-size: 13px;
      flex-shrink: 0;
    }
  }

  .shortcut-hint {
    width: 90vw;
    max-width: 320px;

    .shortcut-list {
      grid-template-columns: 1fr;
    }
  }
}

// 滚动条样式
.tabs-header::-webkit-scrollbar {
  height: 4px;
}

.tabs-header::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}

.tabs-header::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

.tabs-header::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
